export const loadState = (name) => {
  try {
    const serializedData = localStorage.getItem(name)
    if (serializedData === null) {
      return undefined
    }
    return JSON.parse(serializedData)
  } catch (error) {
    console.error('get: ', error)
    return undefined
  }
}
export const saveState = (name, state) => {
  try {
    let serializedData = JSON.stringify(state)
    localStorage.setItem(name, serializedData)
  } catch (error) {
    console.error('set: ', error)
  }
}
